import {
    Component, OnInit,
    ViewChild, ElementRef, Input, Output, EventEmitter, ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';

import { AlertService, AlertComponent } from '../alert';

class ChildElement {
    constructor(private el: ElementRef) { }
    get nativeElement() {
        return this.el.nativeElement;
    }
    on(events: string, handler: Function) {
        let theEvents = events.split(" ");
        theEvents.forEach((event: string) => {
            this.nativeElement.addEventListener(event, handler);
        });
        return this;
    }
    addClass(cls: string) {
        this.nativeElement.classList.add(cls);
    }
    removeClass(cls: string) {
        this.nativeElement.classList.remove(cls);
    }
}

@Component({
    selector: 'drop-file',
    templateUrl: './drop-file.component.html',
    styleUrls: ['./drop-file.component.scss']
})
export class DropFileComponent implements OnInit {
    @ViewChild('boxFile') boxFile: ElementRef;
    @Output() files = new EventEmitter();
    @Input() accept: string = 'image/jpeg,image/png';
    @Input() limit: number = 0;
    @Input() limitLength: number = 0;
    @Input() disable: boolean = false;
    @Input() sendIfValid: boolean = false;
    @Input() showFileName: boolean = false;
    @Input() label: string = '';
    @Input() texts = {
        choose: 'Elegir archivos',
        drop: 'o poner aquí'
    }
    fileBuffer: File[] = [];
    name: string = '';
    @ViewChild('alert',
        { read: ViewContainerRef }) private alertRef: ViewContainerRef;
    constructor(private _cfr: ComponentFactoryResolver, private _alertService: AlertService) { }
    private get isAdvancedUpload() {
        let form = this.boxFile.nativeElement;
        return (
            ('draggable' in form) || ('ondragstart' in form && 'ondrop' in form))
            && 'FormData' in window && 'FileReader' in window;
    }
    private get isInvalid() {
        return this.invalid || this.disable;
    }
    private invalid = false;
    ngOnInit() {
        if (this.isAdvancedUpload) {
            let box: ChildElement = new ChildElement(this.boxFile);
            box.addClass('has-advanced-upload');
            box.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
                e.preventDefault();
                e.stopPropagation();
            })
                .on('dragover dragenter', () => {
                    box.addClass('is-dragover');
                })
                .on('dragleave dragend drop', () => {
                    box.removeClass('is-dragover');
                })
                .on('drop', (e) => {
                    this.processFiles(e.dataTransfer.files);
                });
        }
    }
    droppedFiles = [];
    private change(e) {
        this.processFiles(e.srcElement.files);
    }
    private processFiles(files) {
        this.invalid = false;
        this.droppedFiles = [];
        let totalSize: number = 0;
        let notAcceptedCount: number = 0;
        let fileCount: number = 0;
        Array.from(files).forEach((file: any) => {
            if (this.validateType(file)) {
                totalSize += file.size;
                this.droppedFiles.push(file);
                fileCount++;
            }
            else {
                notAcceptedCount++;
            }
        });
        if (notAcceptedCount) {
            this.invalid = true;
            this.invalidTypes(notAcceptedCount);
        }
        if (this.limitLength && fileCount > this.limitLength) {
            this.invalid = true;
            this.tooMany(fileCount);
        }
        if (this.limit && !this.validateSize(totalSize)) {
            this.invalid = true;
            this.overSized(totalSize);
        }
        if (!this.invalid) this.clearMessages();
        if (this.sendIfValid && this.invalid) return;
        this.fileBuffer = this.droppedFiles;
        if (this.showFileName) {
            this.name = '';
            this.fileBuffer.forEach(file => {
                this.name = `${this.name} ${file.name}`;
            });
        }
        this.files.emit({ data: this.droppedFiles, size: totalSize });
    }
    private validateType(currFile) {
        return currFile.type && this.accept.includes(currFile.type);
    }
    private validateSize(currSum) {
        return currSum <= this.limit;
    }
    private showAlert(target) {
        this[target].clear();
        let factory = this._cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.instance.click.subscribe((event: any) => {
            setTimeout(() => { this.invalid = false; }, 150);
        });
        ref.changeDetectorRef.detectChanges();
    }
    alertD(message, type: 'error' | 'success' | 'warning' = 'error') {
        this.showAlert('alertRef');
        this._alertService[type](message);
    }
    invalidTypes(notAcceptedCount) {
        let na = notAcceptedCount;
        this.alertD(`${notAcceptedCount} archivo${(na > 1) ? 's' : ''} excluido${(na > 1) ? 's' : ''}.
                Requisito: ${this.accept}`);
    }
    overSized(currSize = 0) {
        let output = '';
        if (currSize) output += `Tamaño actual: ${(currSize / 1000000).toFixed(2)} MB. `;
        output += `El tamaño limite es: ${(this.limit / 1000000).toFixed(2)} MB`;
        this.alertD(output);
    }
    tooMany(currLength = 0) {
        let output = '';
        if (currLength) output += `Tamaño actual: ${(currLength)}. `;
        output += `La cantidad limite es: ${(this.limitLength)}`;
        this.alertD(output);
    }
    clearMessages() {
        this.alertRef.clear();
        setTimeout(() => { this.invalid = false; }, 150);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/drop-file/drop-file.component.ts